import { gql } from "@apollo/client";

const ADD_ASSET = gql`
  mutation AddAsset(
    $productId: ID
    $plaidAccountId: String
    $name: String!
    $type: String!
    $balance: Float!
    $cash: Float
    $stockHoldings: Float
    $impactInvestments: Float
    $other: Float
    $brokerageName: String
    $brokerageAccountNumber: Int
  ) {
    addAsset(
      product_id: $productId
      plaid_account_id: $plaidAccountId
      name: $name
      type: $type
      balance: $balance
      cash: $cash
      stocks: $stockHoldings
      impact_investments: $impactInvestments
      other: $other
      brokerage_name: $brokerageName
      brokerage_account_number: $brokerageAccountNumber
    ) {
      _id
      product_id
      name
      type
      balance
      cash
      stocks
      plaid_account_id
      brokerage_name
      brokerage_account_number
      impact_investments
      other
    }
  }
`;

const CREATE_ASSET = gql`
  mutation CreateAsset($args: CombinedCreateAssetInput!) {
    createAsset(args: $args) {
      ... on AccountAsset {
        _id
        assetName
      }
      ... on EquityAsset {
        _id
      }
      ... on EquitySourceAsset {
        _id
        assetName
      }
      ... on LendingAsset {
        _id
      }
      ... on CryptoAsset {
        _id
      }
    }
  }
`;

const UPDATE_ASSET = gql`
  mutation UpdateAsset($args: CombinedUpdateAssetInput!, $assetId: ID!) {
    updateAsset(args: $args, assetId: $assetId) {
      ... on AccountAsset {
        _id
      }
      ... on EquityAsset {
        _id
      }
      ... on CryptoAsset {
        _id
      }
    }
  }
`;

const UPDATE_CRYPTO_ROW_HOLDINGS = gql`
  mutation UpdateCryptoRowHoldings($assetId: ID!, $row: Int!, $quantity: Decimal128!, $ticker: String!) {
    updateCryptoRowHoldings(assetId: $assetId, row: $row, quantity: $quantity, ticker: $ticker)
  }
`;

const DELETE_CRYPTO_ROW_HOLDINGS = gql`
  mutation DeleteCryptoRowHoldings($assetId: ID!, $row: Int!) {
    deleteCryptoRowHoldings(assetId: $assetId, row: $row)
  }
`;

const DELETE_ASSET = gql`
  mutation DeleteAsset($assetId: ID!) {
    deleteAsset(assetId: $assetId) {
      ... on AccountAsset {
        _id
      }
      ... on CryptoAsset {
        _id
      }
      ... on EquityAsset {
        _id
      }
      ... on FundAsset {
        _id
      }
      ... on LendingAsset {
        _id
      }
      ... on OtherAsset {
        _id
      }
      ... on InternalAccountAsset {
        _id
      }
    }
  }
`;

export { ADD_ASSET, UPDATE_CRYPTO_ROW_HOLDINGS, DELETE_CRYPTO_ROW_HOLDINGS, CREATE_ASSET, UPDATE_ASSET, DELETE_ASSET };